<!--
	ServiceCreatePage.svelte

    Here we are updating the masterCreateService object

    TODO: renable isFormValid check for SUBMIT CREATE button
-->

<script>
    import {onMount} from 'svelte';
    import {fly, fade} from 'svelte/transition';
    import {pop, push} from 'svelte-spa-router';
    import {requestCreateService2} from '../../api/services.ts';

    import {SERVICE_NAME, DESCRIPTION} from '../../common/constants.js';
    import {setWarningAlert, setErrorAlert, setInfoAlert, PENDING_MSECS} from '../../stores/AlertsStore';
    import {fetchAllFieldsPresets} from '../../stores/FieldPresetsStore.js';
    import {masterCreateService} from '../../common/master-objects.js';

    import {AccountStore} from "../../common/account";


    // TCARE components
    import PageBanner from '../../components/common/PageBanner.svelte';
    import ServiceCreateFields from '../../components/services/ServiceCreateFields.svelte';

    // $: isFormValid = getIsFormValid($masterCreateService.apiData);

    // SMUI components
    import Button, {Label, Icon} from '@smui/button';
    import {Svg} from '@smui/common/elements';
    import {mdiArrowLeftTop, mdiCheck, mdiClose} from '@mdi/js';

    const SUBMIT_PENDING_MSG = 'Submitting your new service for review - click to cancel';
    const SUBMIT_ERROR_MSG = 'Error while submitting your new service.';
    const SUBMIT_SUCCESS_MSG = 'Successfully submitted your new service for review.';
    const CANCEL_INFO_MSG = 'Your updates have been cancelled.';
    const FORM_INVALID_MSG = 'Please enter the service Name and Description.';

    onMount(async () => {

        if (!$AccountStore?.isLoggedIn) {
            push('/');
        }

        fetchAllFieldsPresets();
        // console.log('ServiceCreatePage fetching all fields presets');

        $masterCreateService.clearApiData();
        $masterCreateService = $masterCreateService;

        scrollTo(0, 0);
    })

    // does this need to respond to keystrokes?
    const getIsFormValid = (serviceApiData) => {
        return (serviceApiData[SERVICE_NAME] !== '') && (serviceApiData[DESCRIPTION] !== '');
    }

    // include the callback for after the message completes
    const submitUpdates = () => {
        // POST /intake/upsert-service

        if (!getIsFormValid($masterCreateService.apiData)) {
            setWarningAlert(FORM_INVALID_MSG, 2000);
            return;
        }

        $masterCreateService.flattenTaxonomiesNodesToApiData();
        const body = {
            "leftServiceIds": null,
            "rightService": $masterCreateService.apiData
        }
        body.rightService.source = $AccountStore?.username ?? "n/a";     // source is the user?

        // passing in the function - will not run if Alert is cancelled
        setInfoAlert(SUBMIT_PENDING_MSG, PENDING_MSECS, async () => {
            let json = await requestCreateService2(body);
            if (!json.errors) {
                $masterCreateService.clearApiData();
                $masterCreateService = $masterCreateService;
                setInfoAlert(SUBMIT_SUCCESS_MSG, 2000);
                pop();
            } else {
                setErrorAlert(SUBMIT_ERROR_MSG, 2000);         // based on API success
            }
        });
    }

    // data will get reset again on next load
    const cancelUpdates = () => {
        // setInfoAlert(CANCEL_INFO_MSG, 1000, () => pop());
        pop();          // no alert message for Cancel
    }

</script>

<style>

    :global(.create-service .mdc-button) {
        /* text-transform: none; */
        border-radius: 18px;
        overflow: hidden;
    }

    :global(.bottom-buttons .mdc-button) {
        background-color: var(--tcare-purple) !important;
    }


    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="page-content create-service" in:fly="{{ x: 200, duration: 500 }}" out:fade="{{ duration: 250 }}">

    {#if $masterCreateService.apiData}
        <div class="spacer-h-10"></div>
        <PageBanner title={"Create new Service"}/>
        <div class="spacer-h-25"></div>

        <!-- TODO: THIS SHOULD BE A SUBMIT PANEL {#if isFormValid} -->
        <div class="flex-row top-buttons">
            <Button color="primary" on:click={() => cancelUpdates()} variant="outlined">
                <Label>Cancel and Return</Label>
                <Icon component={Svg} viewBox="0 0 24 24">
                    <path d={mdiArrowLeftTop}/>
                </Icon>
            </Button>
            <Button color="primary" on:click={() => submitUpdates()} variant="outlined">
                <Label>Submit new Service</Label>
                <Icon component={Svg} viewBox="0 0 24 24">
                    <path d={mdiCheck}/>
                </Icon>
            </Button>
        </div>

        <!-- pass blank copy here since we are creating a new service -->
        <div class="spacer-h-20"></div>
        <ServiceCreateFields store={masterCreateService}/>

        <div class="spacer-h-50"></div>

        <div class="flex-row jc-center bottom-buttons">
            <Button color="primary" on:click={() => submitUpdates()} variant="raised">
                <Label>Submit new Service</Label>
                <Icon component={Svg} viewBox="0 0 24 24">
                    <path d={mdiCheck}/>
                </Icon>
            </Button>
        </div>

        <div class="spacer-h-50"></div>
    {/if}

</div>
